export default __webpack_public_path__ + "041120b7d2367dba47c449266c797bce.png";